import React from 'react';
import numberListHelper from '../utils/numberListHelper';

const componentClass = 'trackList';

const ContentTrackList = ({ trackSets, onClick, shouldRenderDetails }) => {
    const renderListOfTracks = (tracks, setIndex) => (tracks || []).map((t,i) => {
        const { title } = t;
        const onTrackClicked = () => {
            onClick && onClick(i, setIndex);
        };
        return <li key={i} onClick={onTrackClicked}>
            <span>{ numberListHelper(i + 1)} { title }</span>
        </li>
    });

    const trackSetsRender = (trackSets || []).map((set, i) => {
        const { title, description, tracks } = set;
        return <div className={`${componentClass}__set`} key={i}>
            <h3>{ title || 'Tracks' }</h3>
            { description && <p>{ description }</p> }
            <ul>{ renderListOfTracks(tracks, i) }</ul>
        </div>
    })

    return <div className={componentClass}>{ trackSetsRender }</div>;
};

export default ContentTrackList;
